export function initRatingInputs(): void {
  const containers =
    document.querySelectorAll<HTMLElement>(".star-rating-input");

  containers.forEach((container) => {
    if (container.dataset.initialized) return;
    container.dataset.initialized = "true";

    const input = container.querySelector<HTMLInputElement>(
      'input[type="hidden"]',
    );
    const buttons = container.querySelectorAll<HTMLButtonElement>(".star-btn");
    const label = container.querySelector<HTMLElement>(".rating-label");

    const labels: Record<number, string> = {
      1: "1.0 - Avoid",
      1.5: "1.5 - Quite poor",
      2: "2.0 - Poor",
      2.5: "2.5 - Could be better",
      3: "3.0 - Okay",
      3.5: "3.5 - Pretty good",
      4: "4.0 - Good",
      4.5: "4.5 - Very good",
      5: "5.0 - Excellent",
    };

    function updateStars(rating: number): void {
      buttons.forEach((btn) => {
        const val = parseFloat(btn.dataset.rating || "0");
        const svg = btn.querySelector<SVGElement>("svg");

        if (svg) {
          if (val <= rating) {
            svg.style.fill = "var(--accent-gold)";
            svg.style.stroke = "var(--accent-gold)";
          } else {
            svg.style.fill = "none";
            svg.style.stroke = "#d1d5db"; // Light gray
          }
        }
      });
      if (label) {
        label.textContent = labels[rating] || "Click to rate";
      }
    }

    // Init
    let currentRating = parseFloat(container.dataset.value || "0");

    if (currentRating < 1.0 && currentRating > 0) {
      // If it's a 0.5 rating from backend, force to 1.0
      currentRating = 1.0;
      if (input) input.value = currentRating.toString();
    } else if (currentRating === 0) {
      // If it's 0 (unrated), keep input empty
      if (input) input.value = "";
    } else {
      // Otherwise, use the rating as is
      if (input) input.value = currentRating.toString();
    }
    updateStars(currentRating);

    buttons.forEach((btn) => {
      btn.addEventListener("mouseenter", () => {
        updateStars(parseFloat(btn.dataset.rating || "0"));
      });

      btn.addEventListener("click", () => {
        currentRating = parseFloat(btn.dataset.rating || "0");
        if (input) input.value = currentRating.toString();
        updateStars(currentRating);
        // Add a little pop animation
        const svg = btn.querySelector<SVGElement>("svg");
        if (svg) {
          svg.style.transform = "scale(1.3)";
          setTimeout(() => (svg.style.transform = "scale(1)"), 150);
        }
      });
    });

    const row = container.querySelector<HTMLElement>(".stars-row");
    if (row) {
      row.addEventListener("mouseleave", () => {
        updateStars(currentRating);
      });
    }
  });
}

document.addEventListener("turbo:load", initRatingInputs);
document.addEventListener("DOMContentLoaded", initRatingInputs);
